"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExposableObject = void 0;
const _ = require("lodash");
class ExposableObject {
    toJSON() {
        // If the class has exposable attributes, return these
        if (this.exposableAttributes) {
            return _.omit(_.pick(this, this.exposableAttributes), "exposableAttributes");
        }
        // Otherwise return the object itself
        return this;
    }
}
exports.ExposableObject = ExposableObject;
//# sourceMappingURL=exposable_object.js.map